export * from './WixStudioBulletSplitPantone'
import React, { FC } from 'react'

import { markAsWixStudioAccount } from '../../../api/StudioWorkspaceService/markAsWixStudioAccount'
import { unmarkAsWixStudioAccount } from '../../../api/StudioWorkspaceService/unmarkAsWixStudioAccount'
import { WixStudioBulletSplitPantone as WixStudioBulletSplitPantoneUnwrapped } from './WixStudioBulletSplitPantone'

type WixStudioBulletSplitPantoneProps = {}

export const WixStudioBulletSplitPantone: FC<WixStudioBulletSplitPantoneProps> = props => {
  return (
    <WixStudioBulletSplitPantoneUnwrapped
      {...props}
      markAsWixStudioAccount={markAsWixStudioAccount}
      unmarkAsWixStudioAccount={unmarkAsWixStudioAccount}
    />
  )
}
